import { Button, Col, Flex, Form, Modal, Row, Space } from "antd";
import { Alert } from "components/elements";
import { FormDatePicker, FormInput, FormInputNumber } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import EmployeeInfoWorkExperienceTable from "components/table/EmployeeInfoWorkExperienceTable";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatDate } from "utils/formatter";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import {
  initialValues as INITIAL_VAUES,
} from "../schemas/employeeInfoWorkExperienceSchema";

function EmployeeInfoWorkExperience({
  isLoading = false,
  initialValues = {},
  workExperienceList = [],
  pagination = {},
  isModalOpen = false,
  dataDetail = {},
  onSubmit = () => { },
  onEdit = () => { },
  onCancel = () => { },
  onCreate = () => { },
  onDelete = () => { },
  onChange = () => { },
  setIsModalOpen = () => { },
}) {
  const { t } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  return (
    <Space style={{ width: "100%" }} size={16} direction="vertical">
      <Modal
        destroyOnClose
        title={
          initialValues?.id ? t('common.edit') : t('common.create')
        }
        open={isModalOpen}
        onCancel={() => {
          const cancelBtn = document.getElementById(
            "cancelBtn"
          );
          if (cancelBtn) {
            cancelBtn.click();
          } else {
            onCancel();
          }
        }}
        footer={null}
        width={"50%"}
        closable={false}
        maskClosable={false}
      >
        <FormAntd
          initialValues={{ ...INITIAL_VAUES, ...initialValues, }}
          onFinish={(s) => {
            if (dayjs(s?.startDate).isAfter(dayjs(s?.endDate))) {
              Alert({ message: "start date must be before end date", type: 'error' })
            } else {
              onSubmit(s)
            }
          }}
        >
          <Form.Item shouldUpdate={(prev, curv) => prev['startDate'] != curv['startDate']} >
            {({ getFieldValue, setFieldValue, submit }) => {
              return (
                <Flex vertical gap={16}>
                  {/* <Divider /> */}
                  <Row gutter={[0, 20]}>
                    <Col span={12} style={{ paddingRight: "12px" }}>
                      <FormInput
                        required={true}
                        name="company"
                        label={t('signup.input.companyName')}
                        placeholder={t('fill-in-company-name')}
                        size="large" />
                    </Col><Col span={12}></Col>
                  </Row><Row gutter={[0, 20]} >
                    <Col span={12} style={{ paddingRight: "12px" }}>
                      <FormInput
                        required={true}
                        name="position"
                        label={t('employee.latest-position')}
                        placeholder={t('fill-in-latest-position')}
                        size="large" />
                    </Col>
                    <Col span={12} style={{ paddingLeft: "12px" }}>
                      <FormInputNumber
                        name="salary"
                        label={t('employee.latest-salary')}
                        placeholder="0.00"
                        size="large"
                        controls={false}
                        textAlign="right"
                      />
                    </Col>
                  </Row>
                  <Row gutter={[0, 20]}>
                    <Col span={12} style={{ paddingRight: "12px" }}>
                      <FormDatePicker
                        name="startDate"
                        label={t("holiday.label.start_date")}
                        placeholder={t('common.placeholder.ddmmyyyy')}
                        size="large"
                        format={formatDate()}
                        rules={[
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              const startDate = getFieldValue('startDate');
                              const endDate = getFieldValue('endDate');

                              // if (!startDate) {
                              //   return Promise.reject(new Error(`${t('common.please_fill')} ${t("holiday.label.start_date")}`));
                              // }

                              const startDateFormat = dayjs(startDate).startOf('day');
                              const endDateFormat = dayjs(endDate).startOf('day');
                              if (endDateFormat.isBefore(startDateFormat)) {
                                return Promise.reject(new Error(t('holiday.error.start_date_not_affter_end_date')));
                              }

                              return Promise.resolve();
                            },
                          }),
                        ]}

                      />
                    </Col>
                    <Col span={12} style={{ paddingLeft: "12px" }}>
                      <FormDatePicker
                        name="endDate"
                        minDate={getFieldValue("startDate")}
                        label={t("holiday.label.end_date")}
                        placeholder={t('common.placeholder.ddmmyyyy')}
                        size="large"
                        format={formatDate()} />
                    </Col>
                  </Row><Row gutter={[0, 20]} >
                    <Col span={24} >
                      <FormInput
                        name="responsibility"
                        label={t('employee.responsibility')}
                        placeholder={t('identify-the-responsibilities-and-duties-assigned')}
                        size="large"
                        type="textarea"
                        rows={4}
                      />
                    </Col>
                  </Row><Row justify="end" >
                    <Space direction="horizontal" size={12}>
                      <Button
                        id="cancelBtn"
                        type="default"
                        onClick={() => {
                          onCancel();
                        }}
                        style={{ borderRadius: 8, padding: "8px 16px", width: "max-content", height: "max-content" }}
                      >
                        {t("common.cancel").toUpperCase()}
                      </Button>
                      <Button htmlType="submit" type="primary"
                        style={{ borderRadius: 8, padding: "8px 16px", width: "max-content", height: "max-content", backgroundColor: "var(--button-color)" }}
                      >
                        {t("common.submit").toUpperCase()}
                      </Button>
                    </Space>
                  </Row>
                </Flex>
              );
            }}
          </Form.Item>
        </FormAntd>
      </Modal>
      {
        roles.includes("CREATE_EMPLOYEE|EMPLOYEE_INFO|WORK_EXPERIENCE") &&
        <Row justify="end">
          <Button onClick={(e) => {
            onCreate();
          }}
            style={{ width: "max-content", height: "max-content", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "10px 16px" }}
            type="primary"
          >
            <Flex align="center" justify="center" gap={8}>
              <CreateIcon />
              {t("common.create")}
            </Flex>
          </Button>
        </Row>
      }

      <EmployeeInfoWorkExperienceTable
        isLoading={isLoading}
        dataSource={workExperienceList}
        pagination={pagination}
        onChange={onChange}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    </Space>
  );
}

export default EmployeeInfoWorkExperience;
